module.exports = __webpack_public_path__ + "static/media/cyan_hex.f1cbf2f3.svg";